<template>
    <views class="improve-info">
        <nav-bar
            :title="moduleTitle"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="improve-info-content">
            <views
                v-for="(item, index) in list"
                :key="index">
                <info-item v-model="list[index]"></info-item>
            </views>
        </views>
        <views v-if="list.length > 0" class="improve-info-button">
            <button class="primary" @click="save">保存</button>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import InfoItem from './InfoItem'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar,
        InfoItem
    },
    mixins: [tools],
    data() {
        return {
            moduleTitle: '完善资料',
            list: [],
            defaultList: []
        }
    },
    mounted() {
        this.setBgColor()
        this.getMemberCustom()
    },
    destroyed() {
        this.resetBgColor()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        getMemberCustom() {
            api.getMemberCustom().then((res) => {
                if (res.data) {
                    this.list = this.setDefaultValue(res.data)
                }
            })
        },
        setDefaultValue(arr) {
            const _arr = []
            arr.map((item) => {
                _arr.push({
                    ...item,
                    value: item.value || item.default_value
                })
            })
            return _arr
        },
        save() {
            console.log(this.list)
            const a = this.list.filter(item => item.type < 4 && !item.value && item.is_required)
            if (a.length > 0) return this.notify('有必填项未填写')
            const params = {
                list: this.list.filter(item => item.type < 4).map(item => ({
                    id: item.id,
                    value: item.value
                }))
            }
            api.saveCustom(params).then(() => {
                this.sucMsg('保存成功')
                setTimeout(() => {
                    this.$router.go(-1) // 后退
                }, 800)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
